<template>
  <div>
      <div class="container">
          <!-- 保险期限 -->
        <div class="wrapper">
            <h3 class="title flex">保险期限</h3>
            <a-form-model layout="inline" :model="saveForm" :rules="formRule" ref="saveForm" class="insure-form">
                <a-form-model-item label="起保日期">
                    <a-date-picker :disabled="disabledAll" v-model="saveForm.effectiveDate" :disabledDate="disabledBeginDate" :allowClear="false" format="YYYY-MM-DD" value-format="YYYY-MM-DD" @change="effectiveDateChange"></a-date-picker>
                </a-form-model-item>
                <a-form-model-item label="起止">
                    <a-date-picker disabled v-model="saveForm.expireDate" :allowClear="false" format="YYYY-MM-DD"></a-date-picker>
                    <span class="insure-days">共计{{sumDays}}天</span>
                </a-form-model-item>
            </a-form-model>
        </div>
        <!-- 投保方案 -->
        <div class="wrapper">
            <h3 class="title flex">投保方案</h3>
            <insuredInfo :formData="form" :riskData="riskInfos" :disabledAll="disabledAll" ref="insured" @collectData="collectData" />
        </div>
        <!-- 投保人信息 -->
        <div div class="wrapper">
            <h3 class="title flex">投保人信息</h3>
            <applicantInfo :formData="form" ref="applicant" :disabledAll="disabledAll" @collectData="collectData" />
        </div>
        <!-- 询价人信息 -->
        <div div class="wrapper">
            <h3 class="title flex">询价人信息</h3>
            <quoteInfo ref="quoteInfo" :formData="form" :disabledAll="disabledAll" @collectData="collectData" />
        </div>
        <!-- 询价资料 -->
        <div div class="wrapper">
            <h3 class="title flex">询价资料</h3>
            <uploadFile ref="uploadFile" :formData="form" :disabledAll="disabledAll" :inquiryInformation="inquiryInformation" @collectData="collectData" />
        </div>
        <!-- 投保备注 -->
        <!-- <div div class="wrapper">
            <h3 class="title flex">投保备注</h3>
            <a-form-model layout="horizontal" :model="saveForm" :colon="false" :rules="formRule" ref="saveForm" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <a-form-model-item label="备注信息">
                    <a-textarea :disabled="disabledAll" v-model="saveForm.remark" :auto-size="{minRows: 3, maxRows:5}" placeholder="非必填项"></a-textarea>
                </a-form-model-item>
            </a-form-model>
        </div> -->
        <div class="operate-btns text-center">
            <div v-if="! disabledAll">
                <a-button type="primary" @click="saveGroupAFP">保存询价</a-button>
                <a-button type="primary" @click="downloadPdf(resultAFP.tobUrl)">生成计划书</a-button>
                <a-button type="primary" @click="downloadPdf(resultAFP.polUrl)">生成投保单</a-button>
            </div>
            <a-button v-else type="primary" @click="openEdit">编辑</a-button>
        </div>
        <div class="fix-btn" @click="serachQuoteData">询价管理</div>
      </div>
        <a-modal :width="1000" title="询价信息查询" @cancel="isSearchQuoteData = false" :visible="isSearchQuoteData" :footer="null">
            <a-form-model layout="inline" :model="quoteForm" :colon="false" :rules="quoteFormRule" ref="quoteForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <a-form-model-item label="询价单号" prop="appQuesNo">
                    <a-input v-model="quoteForm.appQuesNo" allow-clear />
                </a-form-model-item>
                <a-form-model-item>
                    <a-button type="primary" @click="serachQuoteSubmit">查询</a-button>
                </a-form-model-item>
            </a-form-model>
            <a-table :columns="column" :data-source="quoteData" size="small" :locale="{emptyText: '暂无数据'}" :pagination="false" class="quote-data-table">
                <div slot="operation" slot-scope="record">
                    <a-button v-if="record.status === '-1'" type="link" class="mar-right10" @click="toEditData(record)" >
                        编辑
                    </a-button>
                </div>
            </a-table>
        </a-modal>
  </div>
</template>

<script>
import moment from 'moment';
import insuredInfo from './components/insuredInfo/index.vue'
import quoteInfo from './components/quoteInfo.vue'
import applicantInfo from './components/applicantInfo.vue'
import uploadFile from './components/uploadFile.vue'

export default {
    components: {
        insuredInfo,
        quoteInfo,
        applicantInfo,
        uploadFile
    },
    beforeRouteUpdate(to, form, next) {
        this.queryOrderDetails(to.query.appQuesNo)
        next()
    },
    data() {
        const today = moment(new Date()).format('YYYY-MM-DD')
        const afterYear = moment(new Date()).add(1, 'year').format('YYYY-MM-DD')
        const column = [
            { title: "询价编号", dataIndex: "id"},
            { title: "投保人", dataIndex: "contactsName"},
            { title: "状态", dataIndex: "status", customRender: (val) => {
                for (let i = 0; i < this.statusCode.length; i ++) {
                    if (this.statusCode[i].code === val) {
                        return this.statusCode[i].name
                    }
                }
                return val
            }},
            { title: "保费", dataIndex: "totalPremium"},
            { title: "创建日期", dataIndex: "createDate", customRender: (val) => {
                return moment(val).format('YYYY-MM-DD')
            }},
            { title: "最近更新日期", dataIndex: "updataDate", customRender: (val) => {
                return moment(val).format('YYYY-MM-DD')
            }},
            { title: "操作", key: "operation", align: "center", width: "80px", scopedSlots: { customRender: "operation" }}
        ]
        return {
            inquiryInformation: 'quotation_TaMedilinkGroup_' + moment(new Date()).format('YYYYMMDDHHmmss'),
            isSearchQuoteData: false,
            form: {
                isNewPolicy: 'Y',
                fileUrls: [],
            }, // 页面表单初始化的数据对象
            formRule: {},
            saveForm: { // 当前页表单绑定的数据对象 及收集子组件的数据对象 和初始化的数据对象分开 不然会被覆盖
                effectiveDate: today,
                expireDate: afterYear,
            },
            resultAFP: {
                tobUrl: null, // 生成计划书链接
                polUrl: null // 生成投保单链接
            },
            riskInfos: [{}],
            column,
            quoteForm: {
                appQuesNo: '',
            },
            quoteData: [],
            disabledAll: false,
            quoteFormRule: {
                appQuesNo: [
                    { required: true, message: "请输入询价单号" }
                ]
            },
            statusCode: [
                { code: '-1', name: '未提交' },
                { code: '-2', name: '审批中' },
                { code: '-3', name: '审批退回' },
                { code: '0', name: '待核保' },
                { code: '5', name: '核保中' },
                { code: '6', name: '核保通过' },
                { code: '7', name: '拒保' },
                { code: '11', name: '核保通过|缺失' }
            ]
        }
    },
    computed: {
        // 总天数
        sumDays() {
            return moment(this.saveForm.expireDate).diff(this.saveForm.effectiveDate, 'day')
        }
    },
    created() {
        const { u, p, appQuesNo } = this.$route.query || {}
        this.form.planCode = p
        this.form.productCode = p
        this.form.webCustomerId = u
        this.queryOrderDetails(appQuesNo);
    },
    methods: {
        disabledBeginDate(current) {
            if (! current) {
                return false
            }
            const monthBrfore = moment(new Date()).subtract(1, 'month').format('YYYY-MM-DD')
            return current < moment(monthBrfore).endOf('day')
        },
        // 天数大于365天，则把结束日期置为开始日期之后的第365天
        effectiveDateChange(date) {
            if (!date) {
                return true;
            }
            const afterYear = moment(date).add(1, 'year').format('YYYY-MM-DD')
            this.saveForm.expireDate = afterYear
        },
        // 子组件emit数据
        collectData(data){
            this.saveForm = {
                ...this.saveForm,
                ...data
            }
        },
        // 收集子组件数据
        async validateAndCollect() {
          const refProps = ['insured', 'applicant', 'quoteInfo', 'uploadFile']
          for (let i = 0; i < refProps.length; i ++) {
            const refProp = refProps[i];
            let isValidate = null;
            try {
                const fn = this.$refs[refProp].submitHandler
                isValidate = fn ? await fn() : true;
            } catch(error) {
                isValidate = null;
            }
            if (!isValidate) {
              return false;
            }
          }
          return true;
        },
        // 保存询价
        async saveGroupAFP() {
            const isValidate = await this.validateAndCollect()
            if (! isValidate) {
                return false;
            }
            const params = {
                inquiryInformation: this.inquiryInformation, // 编辑的时候会被覆盖掉
                createDate: moment(new Date()).format('x'), // 编辑的时候会被覆盖掉
                ...this.form,
                ...this.saveForm,
                updataDate: moment(new Date()).format('x'),
                fileUrls: undefined
            }
            this.$api.saveGroupAFP(params).then(res => {
                const data = res.data || {}
                if (data.returnCode == '00') {
                    this.$message.success(data.returnMsg || '成功')
                    const {appQuesNo} = data.content || {}
                    this.toEditData({ appQuesNo: appQuesNo || params.appQuesNo })
                }
            })
        },
        // 点击询价管理按钮
        serachQuoteData() {
            this.isSearchQuoteData = true;
            this.quoteForm.appQuesNo = ''
            this.quoteData = []
        },
        // 询价管理查询
        serachQuoteSubmit() {
            this.$refs.quoteForm.validate(valid => {
                if (!valid){
                    return false;
                }
                const data = {
                    ...this.quoteForm,
                    productCode: this.form.productCode
                }
                this.quoteData = []
                this.$api.queryMediLinkQuoAFP(data).then(res => {
                    const data = res.data || {}
                    if (data.returnCode == '00') {
                        const quoteData = data.content || {}
                        this.quoteData = [quoteData]
                    } else {
                        this.$message.error(data.returnMsg || '出错了')
                    }
                })
            })
        },
        // 编辑询价数据
        toEditData(record) {
            const { appQuesNo } = record
            if(!appQuesNo){return false;}
            this.isSearchQuoteData = false;
            this.queryOrderDetails(appQuesNo)

            if (appQuesNo === this.form.appQuesNo) { // 点击编辑的数据和当前查看的是一样的则初始化数据
                return true
            }
            this.$router.replace({
                name: 'gytx',
                query: {
                    ...this.$route.query,
                    appQuesNo
                }
            })
        },
        // 链接后有appQuesNo时查询数据预览 同询价管理查询接口
        queryOrderDetails(appQuesNo){
            if(! appQuesNo) {
                this.disabledAll = false;
                return false;
            }
            this.disabledAll = true;
            const data = {
                appQuesNo,
                productCode: this.form.productCode
            }
            this.$api.queryMediLinkQuoAFP(data).then(res => {
                const data = res.data || {}
                if (data.returnCode == '00') {
                    const { inquiryInformation, riskInfos, polUrl, tobUrl, ...form } = data.content || {}
                    if(inquiryInformation) {this.inquiryInformation = inquiryInformation}
                    this._queryMediLinkQuoAFPFile() // 查询上传的询价资料
                    this.riskInfos = riskInfos && JSON.parse(riskInfos) || []
                    this.resultAFP = { polUrl, tobUrl }
                    this.form = {
                        ...form,
                        effectiveDate: moment(form.effectiveDate).format('YYYY-MM-DD'),
                        expireDate: moment(form.expireDate).format('YYYY-MM-DD')
                    }
                    this.saveForm = this.$lodash.cloneDeep(this.form)
                } else {
                    this.$message.error(data.returnMsg || '出错了')
                }
            })
        },
        // 查询上传的询价资料
        _queryMediLinkQuoAFPFile() {
            this.$api.queryMediLinkQuoAFPFile({inquiryInformation: this.inquiryInformation}).then(res => {
                const data = res.data || {}
                const { fileUrls } = data.content || {}
                this.$set(this.form, 'fileUrls', fileUrls || [])
                // this.form.fileUrls = fileUrls || []
            })
        },
        // 编辑
        openEdit() {
            this.disabledAll = false;
        },
        downloadPdf(url) {
            if(!url){
                this.$message.error("文件尚未生成，请先保存订单！")
                return
            }
            window.open(url, "_blank")
        }
    }

}
</script>

<style lang="scss" scoped>
.flex{
    display: flex;
}
.container{
    padding: 15px 30px;
    ::v-deep .ant-form-item .ant-form-item-label label{
        color: #666
    }
    .insure-days{
        margin-left: 12px;
    }
    .wrapper:not(:last-child){
        margin-bottom: 15px;
    }
    .operate-btns {
        .ant-btn{
            margin: 0 10px;
        }
    }
    .text-center{
        text-align: center;
    }
}
.fix-btn{
    position: fixed;
    bottom: 50%;
    right: 0;
    color: #fff;
    padding: 12px 6px;
    -ms-writing-mode: tb-rl;
    writing-mode: vertical-rl;
    border: 1px solid rgb(254, 143, 45);
    border-right: none;
    background-color: rgb(254, 143, 45);
    margin: 15px 0;
    cursor: pointer;
}
.quote-data-table{
    margin-top: 20px;
}
.title::after {
    content: '';
    display: block;
    flex: 1;
    height: 20px;
    margin-left: 10px;
    background: url("~@/assets/image/title_bg.png") 0 12px repeat-x;

}
</style>